import { useState } from 'react';

import { Button } from "react-bootstrap";

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LicensesDashboardCards from '../../components/admin/licenses/LicensesDashboardCards.jsx';
import LicenseModal from '../../components/admin/licenses/LicenseModal.jsx';
import LicensesTable from '../../components/admin/licenses/LicensesTable.jsx';
import { licenses } from "./data.js";

function LicensesPage(props) {
    const [showModal, setShowModal] = useState(false)

    return <>
        <div className="container">
            <div className="d-flex justify-content-between mb-4">

                <h3 style={{ color: '#fff' }}>Gerenciamento de Licenças</h3>

                <Button onClick={() => setShowModal(true)}>
                    <FontAwesomeIcon icon={faPlus} /> Nova Licença
                </Button>

            </div>
            <LicensesDashboardCards />
            <LicensesTable licenses={licenses} />
            <LicenseModal
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </div>
    </>
}

export default LicensesPage;